import * as Sentry from '@sentry/react'
import { APP_ENV, SENTRY_ORG_ID, SENTRY_WEBSITE_APP_ID } from './consts'

Sentry.init({
  dsn: `https://fc8fbf1cab67339cb1852b2f695d432d@${SENTRY_ORG_ID}.ingest.de.sentry.io/${SENTRY_WEBSITE_APP_ID}`,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: APP_ENV,
  tracesSampleRate: 1.0,
})
